import React from 'react';
import Input from '../../../forms/Input';
import { CONTRACT_TYPES, CONTRACT_TYPE_OPTIONS } from '../../../../constants/settings';
import SelectField from '../../../forms/SelectField';
import TextArea from '../../../forms/TextArea';

const EventReminderInputs = ({ onInput, data, staticData }) => {
    return (
        <React.Fragment>
            <div className="ckp-admin-grid-row is-responsive is-between">
                <div className="ckp-admin-grid-column">
                    <Input
                        id="event-reminder-name"
                        label="Reminder name"
                        autoFocus
                        name="name"
                        value={data.name || ''}
                        onChange={onInput}
                    />
                </div>
                <div className="ckp-admin-grid-column">
                    <SelectField
                        name="contractType"
                        label="Contract Type"
                        onChange={onInput}
                        value={data.contractType}
                        items={
                            staticData.hasAccessToPerformance
                                ? CONTRACT_TYPE_OPTIONS
                                : [{ label: 'Clearance', value: CONTRACT_TYPES.CLEARANCE }]
                        }
                    />
                </div>
                <div className="ckp-admin-grid-column">
                    <Input
                        id="event-reminder-duedate"
                        label="Days Before Due Date"
                        value={data.dueDate || ''}
                        onChange={onInput}
                        inputProps={{ min: 0 }}
                        regex={/^[0-9]\d*/}
                        name="dueDate"
                        type="number"
                        isInteger
                        helperText="The amount of days before the contract's due date a reminder should be sent."
                    />
                </div>
            </div>
            <div className="ckp-admin-grid-row u-margin-top-2">
                <TextArea
                    className="is-full-width"
                    label="Comments"
                    value={data.comments}
                    onChange={onInput}
                    name="comments"
                />
            </div>
        </React.Fragment>
    );
};

export default EventReminderInputs;



// WEBPACK FOOTER //
// ./src/components/admin/forms/events/EventReminderInputs.js